export function getChartOptions(customTooltipConfig = {}) {
  const computedStyle = getComputedStyle(document.body);
  const themeColor = computedStyle.getPropertyValue('--bs-theme').trim() || "#007bff"; // fallback to blue
  const themeColorRgb = computedStyle.getPropertyValue('--bs-theme-rgb').trim() || "0,123,255"; // fallback
  
  // Default tooltip settings for each chart type:
  const defaultBarTooltip = {
    x: { show: false },
    y: { title: { formatter: () => '' } },
  };
  const defaultLineTooltip = {
    x: { show: false },
    y: { title: { formatter: () => '' } },
  };
  const defaultPieTooltip = {
    x: { show: false },
    y: { title: { formatter: () => '' } },
  };
  const defaultDonutTooltip = {
    x: { show: false },
    y: { title: { formatter: () => '' } },
  };

  // Merge custom tooltip config with default values (shallow merge):
  const barTooltip = {
    ...defaultBarTooltip,
    ...(customTooltipConfig.bar || {}),
  };
  const lineTooltip = {
    ...defaultLineTooltip,
    ...(customTooltipConfig.line || {}),
  };
  const pieTooltip = {
    ...defaultPieTooltip,
    ...(customTooltipConfig.pie || {}),
  };
  const donutTooltip = {
    ...defaultDonutTooltip,
    ...(customTooltipConfig.donut || {}),
  };

  return {
    bar: {
      colors: [themeColor],
      chart: { sparkline: { enabled: true } },
      tooltip: barTooltip,
    },
    line: {
      colors: [themeColor],
      chart: { sparkline: { enabled: true } },
      stroke: { curve: "straight", width: 2 },
      tooltip: lineTooltip,
    },
    pie: {
      colors: [
        `rgba(${themeColorRgb}, 1)`,
        `rgba(${themeColorRgb}, .75)`,
        `rgba(${themeColorRgb}, .5)`,
      ],
      chart: { sparkline: { enabled: true } },
      stroke: { show: false },
      tooltip: pieTooltip,
    },
    donut: {
      colors: [
        `rgba(${themeColorRgb}, .15)`,
        `rgba(${themeColorRgb}, .35)`,
        `rgba(${themeColorRgb}, .55)`,
        `rgba(${themeColorRgb}, .75)`,
        `rgba(${themeColorRgb}, .95)`,
      ],
      chart: { sparkline: { enabled: true } },
      stroke: { show: false },
      tooltip: donutTooltip,
    },
  };
}
